import { ErrorLogComponent } from '@cian/error-log-component';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { uaToDeviceType } from '@cian/ui-kit/utils';

import { type FC } from 'react';
import { Provider } from 'react-redux';

import { ApplicationContent } from 'shared/components/ApplicationContent';
import { SsrMarkupFallback } from 'shared/components/SsrMarkupFallback';
import { type IApplicationContext } from 'shared/types/applicationContext';
import { type TReduxStore } from 'shared/types/redux';
import { ApplicationContextProvider } from 'shared/utils/applicationContext';

import { NewbuildingCallbackWidgetProvider } from '../NewbuildingCallbackWidgetProvider';

export interface IApplicationProps {
  reduxStore: TReduxStore;
  context: IApplicationContext;
  /**
   * Снимок серверной разметки корня, снятый в браузере до hydrateRoot. Используется как заглушка
   * корневого error boundary, чтобы ошибка после гидрации не стирала контент. На сервере не передаётся
   */
  ssrMarkup?: string;
}

export const Application: FC<IApplicationProps> = props => {
  const { reduxStore, context, ssrMarkup } = props;
  const { logger, custom } = context;

  return (
    <ErrorLogComponent errorStub={ssrMarkup ? <SsrMarkupFallback html={ssrMarkup} /> : undefined} logger={logger}>
      <ApplicationContextProvider value={context}>
        <MicrofrontendProvider registry={context.microfrontendsRegistry}>
          <UiKitContextProvider deviceType={uaToDeviceType(custom.userAgent)}>
            <NewbuildingCallbackWidgetProvider>
              <Provider store={reduxStore}>
                <ApplicationContent />
              </Provider>
            </NewbuildingCallbackWidgetProvider>
          </UiKitContextProvider>
        </MicrofrontendProvider>
      </ApplicationContextProvider>
    </ErrorLogComponent>
  );
};
